import * as React from 'react'

function isHtml(s: string) {
  return s.startsWith('<') && s.endsWith('>')
}

export function PotentiallyHtml({
  s,
  collapsed = false,
}: {
  s?: string
  collapsed?: boolean
}) {
  if (!s) return <></>
  if (collapsed) {
    return <span>{s.slice(0, 100)}...</span>
  }
  if (isHtml(s.trim())) {
    return <span dangerouslySetInnerHTML={{ __html: s }} />
  }
  return <span>{s}</span>
}
